import { useSearchParams } from 'react-router-dom';
import { usePagination } from '../../../hooks/use-pagination';
import { ArchiveFilter } from '../constants/archive-filter.enum';
import { PRODUCTS_PAGE_SIZE, PRODUCTS_SEARCH_PARAM } from '../constants/products-page.constants';
import { isArchiveFilter } from '../lib/enum-guards';

/** Archive filter + page, both kept in the URL (same pattern as the banner admin). */
export const useArchiveListParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { pagination, isValidPagination, handlePaginationChange, resetPaginationOnSearchParamsChange } = usePagination({
    pageSize: PRODUCTS_PAGE_SIZE,
    pageParamName: PRODUCTS_SEARCH_PARAM.page
  });

  const rawFilter = searchParams.get(PRODUCTS_SEARCH_PARAM.filter);
  const filter = isArchiveFilter(rawFilter) ? rawFilter : ArchiveFilter.ACTIVE;

  const handleFilterChange = (next: ArchiveFilter) => {
    if (next === filter) return;
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.set(PRODUCTS_SEARCH_PARAM.filter, next);
      return resetPaginationOnSearchParamsChange(params);
    });
  };

  return { filter, handleFilterChange, pagination, isValidPagination, handlePaginationChange };
};
